//
// declare module '@mui/material/styles' {
//     interface TypographyVariants {
//         overline2: React.CSSProperties
//     }
//
//     // allow configuration using `createTheme`
//     interface TypographyVariantsOptions {
//         overline2: React.CSSProperties
//     }
// }
//
// // Update the Typography's variant prop options
// declare module '@mui/material/Typography' {
//     interface TypographyPropsVariantOverrides {
//         overline2: true
//     }
// }
export const typographyOptions = (theme) => {
    const { pxToRem } = theme.typography;
    return {
        fontFamily: 'Inter, sans-serif',
        h1: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(96),
        },
        h2: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(64),
        },
        h3: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(48),
        },
        h4: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(36),
        },
        h5: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(32),
        },
        h6: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(20),
        },
        subtitle1: {
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontSize: pxToRem(14),
        },
        body1: {
            fontFamily: 'Inter, Roboto, sans-serif',
            fontSize: pxToRem(16),
            fontWeight: 400,
            lineHeight: 1.4
        },
        body2: {
            fontFamily: 'Inter, Roboto, sans-serif',
            fontSize: pxToRem(13),
            fontWeight: 500,
            lineHeight: 1.35
        },
        button: {
            fontFamily: 'Inter, Roboto, sans-serif',
            fontSize: pxToRem(13),
            fontWeight: 500,
            textTransform: 'uppercase',
            lineHeight: 1
        },
        overline: {
            fontFamily: 'Inter, Roboto, sans-serif',
            fontSize: pxToRem(13),
            lineHeight: 1,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: 'auto'
        },
        overline2: {
            fontFamily: 'Inter, Roboto, sans-serif',
            fontSize: pxToRem(9),
            lineHeight: 1,
            fontWeight: 600,
            textTransform: 'uppercase'
        }
    };
};
//# sourceMappingURL=typography.js.map